import { createSvgIcon } from '@mui/material/utils';
import React, { memo } from 'react';

const SvgIcon = createSvgIcon(
  <path
    key='0'
    fill='#000000'
    d='M18.9,8.8h-2.2V7c0-1.1-0.8-2-2-2H3.6c-1,0-1.9,0.8-1.9,1.9v8.4c0,1,0.8,1.9,1.9,1.9l0,0c0,1.6,1.2,2.8,2.8,2.8
	s2.8-1.2,2.8-2.8h5.6c0,1.6,1.2,2.8,2.8,2.8c1.6,0,2.8-1.2,2.8-2.8h1.2c0.4,0,0.7-0.3,0.7-0.7v-3.4c0-0.4-0.1-0.7-0.4-1l-2.1-2.9
	C19.5,9,19.3,8.8,18.9,8.8z M6.4,18.6c-0.7,0-1.4-0.7-1.4-1.4c0-0.7,0.7-1.4,1.4-1.4s1.4,0.7,1.4,1.4C7.8,17.9,7.2,18.6,6.4,18.6z
	 M19,10.2l1.9,2.3h-4.2v-2.3H19z M17.6,18.6c-0.7,0-1.4-0.7-1.4-1.4c0-0.7,0.7-1.4,1.4-1.4c0.7,0,1.4,0.7,1.4,1.4
	C19,17.9,18.3,18.6,17.6,18.6z'
  />,
  'TransportRounded'
);

const TransportRoundedIcon = function (props) {
  return <SvgIcon {...props} />;
};

export default memo(TransportRoundedIcon);
